// Native details stay usable without JavaScript; deep links reveal their content.
function revealLinkedDetail(hash = window.location.hash) {
  let anchor;
  try { anchor = decodeURIComponent(hash.slice(1)); } catch { return; }
  if (!anchor) return;
  const target = document.getElementById(anchor);
  if (!target) return;
  // Open outer categories before the course itself, including category-only links.
  const ancestors=[];let parent=target.parentElement;
  while(parent){if(parent instanceof HTMLDetailsElement)ancestors.unshift(parent);parent=parent.parentElement;}
  ancestors.forEach(detail=>detail.open=true);
  if (target instanceof HTMLDetailsElement) target.open = true;
  else target.querySelector(':scope > .oh-wrap > [data-course-category]')?.setAttribute('open','');
}
window.addEventListener('hashchange', () => revealLinkedDetail());
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => revealLinkedDetail());
else revealLinkedDetail();

// Clicking the current hash does not fire hashchange. Open before the browser's
// normal anchor navigation, preserving scrolling, history and keyboard behavior.
document.addEventListener('click', event => {
  if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const link = event.target instanceof Element ? event.target.closest('a[href]') : null;
  if (!link || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
  let destination;
  try { destination = new URL(link.href, window.location.href); } catch { return; }
  if (destination.origin !== location.origin || destination.pathname !== location.pathname || destination.search !== location.search) return;
  revealLinkedDetail(destination.hash);
});

// Equipment consent travels with the native cart POST. This is a storefront gate,
// not server-side checkout validation; staff must check the record before capture.
(() => {
  const gateSelector='[data-equipment-acknowledgment]';
  const initialized=new WeakSet();
  function reset(gate,message='') {
    const checkbox=gate.querySelector('input[type="checkbox"]');
    checkbox.checked=false;
    gate.querySelectorAll('[data-equipment-ack-record]').forEach(field=>field.disabled=true);
    checkbox.removeAttribute('aria-invalid');
    const error=gate.querySelector('[data-equipment-ack-error]');
    if(message)error.textContent=message;
    error.hidden=!message;
  }
  function setup() {
    document.querySelectorAll(gateSelector).forEach(gate=>{
      if(initialized.has(gate))return;
      initialized.add(gate);reset(gate);
      gate.querySelector('input[type="checkbox"]').addEventListener('invalid',()=>{
        gate.querySelector('[data-equipment-ack-error]').hidden=false;
      });
    });
    if(document.querySelector(gateSelector+', [data-equipment-quote-block]'))
      document.querySelectorAll('.cart__dynamic-checkout-buttons').forEach(node=>node.hidden=true);
  }
  function validate(form) {
    const quote=document.querySelector('[data-equipment-quote-block]');
    if(quote){quote.setAttribute('tabindex','-1');quote.focus();return false;}
    const gate=[...document.querySelectorAll(gateSelector)].find(node=>!form||node.querySelector('input[type="checkbox"]').form===form);
    if(!gate)return true;
    const checkbox=gate.querySelector('input[type="checkbox"]');
    if(checkbox.checked&&!checkbox.disabled)return true;
    checkbox.setAttribute('aria-invalid','true');
    gate.querySelector('[data-equipment-ack-error]').hidden=false;
    checkbox.focus();checkbox.reportValidity();return false;
  }
  document.addEventListener('click',event=>{
    const target=event.target instanceof Element?event.target.closest('button[name="checkout"],input[name="checkout"],a[href]'):null;
    if(!target)return;
    if(target.tagName==='A'){
      const destination=new URL(target.href,location.href);
      if(destination.origin!==location.origin||!/(?:^|\/)checkout\/?$/.test(destination.pathname))return;
    }
    if(!validate(target.form)){event.preventDefault();event.stopImmediatePropagation();}
  },true);
  document.addEventListener('submit',event=>{
    if(!['cart','CartDrawer-Form'].includes(event.target.id))return;
    if(event.submitter&&event.submitter.name!=='checkout')return;
    if(!validate(event.target)){event.preventDefault();event.stopImmediatePropagation();}
  },true);
  document.addEventListener('change',event=>{
    const input=event.target;
    if(!(input instanceof HTMLInputElement))return;
    const gate=input.closest(gateSelector);
    if(gate&&input.type==='checkbox'){
      gate.querySelectorAll('[data-equipment-ack-record]').forEach(field=>field.disabled=!input.checked);
      input.removeAttribute('aria-invalid');gate.querySelector('[data-equipment-ack-error]').hidden=true;return;
    }
    if(input.name==='updates[]'||input.name.startsWith('updates['))
      document.querySelectorAll(gateSelector).forEach(node=>{
        reset(node,'Your cart changed. Review the updated cart and accept the equipment terms again.');
        node.querySelector('input[type="checkbox"]').disabled=true;
      });
  },true);
  window.addEventListener('pageshow',()=>document.querySelectorAll(gateSelector).forEach(gate=>reset(gate)));
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setup);else setup();
  new MutationObserver(()=>{
    setup();
    if([...document.querySelectorAll('.cart-item__error-text,#cart-errors')].some(node=>node.textContent.trim()))
      document.querySelectorAll(gateSelector+' input[type="checkbox"]:disabled').forEach(input=>input.disabled=false);
  }).observe(document.documentElement,{childList:true,subtree:true});
})();


// One contextual return control for long pages and product-detail popups.
(() => {
  const states=new Map();let scheduled=false;
  const visible=element=>element&&element.getClientRects().length&&!element.closest('[hidden]');
  function context(root){
    const popup=root instanceof HTMLDialogElement;
    const gallery=root.querySelector(popup?'.oh-product-preview__gallery':'[data-native-product] .oh-product-page .oh-shop-gallery');
    if(gallery){
      const tabs=[...root.querySelectorAll('[data-oh-garmin-details] .oh-garmin-tabs')].find(visible);
      return {target:gallery,trigger:tabs||gallery,label:'Back to product photos'};
    }
    if(popup)return null;
    const equipment=root.querySelector('[data-native-catalog] .oh-shop-filter,[data-equipment-catalog] .oh-shop-filter');
    if(visible(equipment))return {target:equipment,trigger:equipment,label:'Back to equipment filters'};
    const training=root.querySelector('[data-training-catalog] .oh-shop-filter');
    if(visible(training))return {target:training,trigger:training,label:'Back to training filters'};
    const main=document.getElementById('MainContent');
    return main?{target:main,trigger:null,label:'Back to top'}:null;
  }
  function create(root){
    if(states.has(root))return;
    const popup=root instanceof HTMLDialogElement;
    const button=document.createElement('button');button.type='button';button.className='oh-scroll-return';button.hidden=true;button.dataset.scrollReturn='';
    button.innerHTML='<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m6 14 6-6 6 6M12 8v11"/></svg>';
    (popup?root:document.body).append(button);
    const clearance=()=>Math.max(0,(popup?root.querySelector('.oh-product-preview__header'):document.querySelector('.oh-nav'))?.getBoundingClientRect().bottom||0)+16;
    const update=()=>{
      const current=context(root);if(!current){button.hidden=true;return;}
      button.setAttribute('aria-label',current.label);button.title=current.label;
      const blocked=popup?!root.open:!!document.querySelector('dialog[open]');
      const passed=current.trigger?current.trigger.getBoundingClientRect().bottom<clearance():scrollY>Math.max(innerHeight*.8,180);
      button.hidden=blocked||!passed;
      if(popup){const bounds=root.getBoundingClientRect();button.style.right=(innerWidth-bounds.right+16)+'px';button.style.bottom=(innerHeight-bounds.bottom+16)+'px';}
    };
    button.addEventListener('click',()=>{
      const current=context(root);if(!current)return;
      const top=current.trigger?Math.max(0,current.target.getBoundingClientRect().top+(popup?root.scrollTop:scrollY)-clearance()):0;
      current.target.tabIndex=-1;current.target.focus({preventScroll:true});
      (popup?root:window).scrollTo({top,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
    });
    if(popup)root.addEventListener('scroll',update,{passive:true});
    states.set(root,{button,update});update();
  }
  function refresh(){
    scheduled=false;
    for(const [root,state] of states)if(root!==document&&!root.isConnected){state.button.remove();states.delete(root);}
    create(document);document.querySelectorAll('dialog.oh-product-preview[open]').forEach(create);
    states.forEach(state=>state.update());
  }
  const schedule=()=>{if(!scheduled){scheduled=true;requestAnimationFrame(refresh);}};
  window.addEventListener('scroll',schedule,{passive:true});window.addEventListener('resize',schedule,{passive:true});
  window.addEventListener('pageshow',schedule);document.addEventListener('change',schedule);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',refresh);else refresh();
  new MutationObserver(schedule).observe(document.documentElement,{childList:true,subtree:true});
})();
